import React from 'react';
import { FormattedMessage } from 'react-intl';
import { GQL } from '@gin-betting/core';
import cn from 'classnames';
import { map } from 'lodash';

import globalMessages from 'messages';
import { checkValueInObj } from 'utils';

import './Tabs.scss';

type Div = React.DOMAttributes<HTMLDivElement>;

interface Props {
    mode: GQL.BetType;
    handleChangeMode: (activeTab: GQL.BetType) => void;
    disabledModes: GQL.BetType[];
    systemPrefix?: string;
}

const tabs = {
    [GQL.BetType.SINGLE]: globalMessages.SINGLE,
    [GQL.BetType.EXPRESS]: globalMessages.EXPRESS,
    [GQL.BetType.SYSTEM]: globalMessages.SYSTEM,
};

const Tabs: React.FC<Props> = ({
    handleChangeMode,
    mode,
    disabledModes,
    systemPrefix,
}) => {
    const handleChooseTab: Div['onClick'] = e => {
        const { tab } = e.currentTarget.dataset;

        if (!tab || !checkValueInObj(GQL.BetType, tab)) return;

        handleChangeMode(tab);
    };

    return (
        <div styleName="container" className="__app-Tabs-container">
            {map(tabs, (msg, value: GQL.BetType) => {
                const isActive = mode === value;
                const isDisabled = disabledModes.includes(value);
                const attrTab = isActive || isDisabled ? undefined : value;
                const isSystem = value === GQL.BetType.SYSTEM;

                return (
                    <div
                        key={value}
                        className={cn('__app-Tabs-item', {
                            '__app-Tabs-is-active': isActive,
                            '__app-Tabs-is-disabled': isDisabled,
                        })}
                        styleName={cn('item', {
                            'is-active': isActive,
                            'is-disabled': isDisabled,
                        })}
                        onClick={handleChooseTab}
                        data-tab={attrTab}
                    >
                        <FormattedMessage {...msg} />
                        {isSystem && systemPrefix && (
                            <div styleName="prefix">{systemPrefix}</div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default Tabs;
